import * as React from "react";
import { Field } from "./Field";

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  requirement?: "required" | "optional";
  hint?: string;
  error?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
};

export function Textarea({
  label,
  value,
  onChange,
  placeholder,
  maxLength,
  requirement,
  hint,
  error,
  disabled,
  id,
  name,
}: Props) {
  const reactId = React.useId();
  const taId = id ?? reactId;

  const stateCls = disabled
    ? "bg-[color:var(--neutral-100)] text-primary/50 cursor-not-allowed border-primary/15"
    : error
      ? "border-error pl-[19px] shadow-[inset_3px_0_0_var(--error)]"
      : "border-primary/15 hover:border-primary/50 focus:border-primary";

  return (
    <Field
      label={label}
      requirement={requirement}
      hint={hint}
      error={error}
      count={maxLength ? { value: value.length, max: maxLength } : undefined}
      htmlFor={taId}
    >
      <textarea
        id={taId}
        name={name}
        value={value}
        maxLength={maxLength}
        placeholder={placeholder}
        disabled={disabled}
        aria-invalid={error && !disabled ? true : undefined}
        onChange={(e) => onChange(e.target.value)}
        className={`min-h-[140px] w-full resize-y border bg-white font-sans font-normal tracking-normal px-4 py-3.5 text-[16px] md:text-[15px] leading-relaxed text-primary placeholder:text-primary/30 outline-none transition-[border-color,background] duration-200 ${stateCls}`}
      />
    </Field>
  );
}
